module.exports = __webpack_public_path__ + "img/3-colorful.d7ed4a76.png";